const handler = require('./retail-key-handler')

export function start(detail) {
      obj[detail.act].start(detail)
}

const obj = {
      add_line_item: { start: (detail) => { handler.add_line_item(detail) } },
}
